import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Typography,
} from 'antd';
import useQuery from 'hooks/useQuery';
import { getVerificarCuenta } from 'api/usuarios/auth';

const { Text } = Typography;

const ActivarCuenta = () => {
  const navigate = useNavigate();
  const [codigo] = useQuery(['codigo']);
  const [respuesta, setRespuesta] = useState('Obteniendo respuesta...');
  if (!codigo) {
    navigate('/inicio-de-sesion');
  }

  useEffect(() => {
    let mounted = true;
    const verify = async () => {
      const verified = await getVerificarCuenta(codigo);
      if (mounted) {
        if (verified) {
          setRespuesta('Tu cuenta a sido activada con éxito presiona Continuar para iniciar en SAC.');
        } else {
          setRespuesta('Lo sentimos. Ha ocurrido un error inesperado, vuelva a intentarlo de nuevo más tarde.');
        }
      }
    };
    verify();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Text style={{ textAlign: 'center' }}>
        {respuesta}
      </Text>
      <br />
      <Button
        className="auth-submit-button"
        style={{
          width: '150px',
        }}
        onClick={() => navigate('/inicio-de-sesion')}
      >
        Continuar
      </Button>
    </>
  );
};

export default ActivarCuenta;
